"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackPageView = trackPageView;
function trackPageView(location) {

  var url = location.pathname + location.search;
  if (typeof window.ga === "function") {
    window.ga("set", "page", url);
    window.ga("send", "pageview");
  }
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/Analytics.js
 ** module id = 1259
 ** module chunks = 0
 **/